var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"content"},[_vm._v("\n\tTopic set by\n\t"),_c('Username',{attrs:{"user":_vm.message.from}}),_vm._v("\n\ton "+_vm._s(_vm.messageTimeLocale)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }